import React                 from "react";

const PageWrapper = ({children}) => 
	<section className="page page-wrapper">{children}</section>
;

export default PageWrapper;